module.exports = __webpack_public_path__ + "officialStatic/img/plus-icon1.786f82d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/plus-icon1.png
// module id = vt5K
// module chunks = 0